import React from 'react'
import { CreateOrders } from '../../organisms/CreateOrders/CreateOrders'
import Layout from 'layout/Layout'
export const CreateOrdersTemplate = () => {
    return (
        <Layout>
            <CreateOrders />
        </Layout>
    )
}
